import { TextFont } from "../../config/StyledComponents";
import { Colors } from "../../config";

const BoxMainHeader = ({ header }) => {
  return (
    <TextFont fontColor={Colors.brandTwo} fontWeight="700" fontSize="1.438rem">
      {header}
    </TextFont>
  );
};

export default BoxMainHeader;
